import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";
import { isSku } from "@omni/utils/product.utils";
import { shallowEqual, useSelector } from "react-redux";

import { getQuery } from "@/redux/modules/value/search/search.selectors";
import { isPageTemplate } from "@/utils/pageTemplate.utils";

import { SearchResultsTitleContextProvider } from "./context/searchResultsTitle.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const query = useSelector(getQuery, shallowEqual);

    const onSearchPage = isPageTemplate(PageTemplate.Search);

    const firstQuery = query.split(" ").at(0);
    const hideTitle = firstQuery && isSku(firstQuery);

    if (!onSearchPage || hideTitle) {
        return null;
    }
    return (
        <SearchResultsTitleContextProvider query={query}>
            {children}
        </SearchResultsTitleContextProvider>
    );
};

export { Base };
